import { render } from "./InertiaButtonEdit.vue?vue&type=template&id=277402c3"
import script from "./InertiaButtonEdit.vue?vue&type=script&lang=js"
export * from "./InertiaButtonEdit.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__